{% block sw_extension_store_error_card %}
<sw-meteor-card
    class="sw-extension-store-error-card"
    :class="componentClasses"
>
    {% block sw_extension_store_error_card_label %}
        <sw-label
            class="sw-extension-store-error-card__label"
            appearance="pill"
            :variant="variant"
        >
            <slot name="icon">
                {% block sw_extension_store_error_card_icon %}
                    <mt-icon
                        :name="iconName"
                        size="30px"
                    />
                {% endblock %}
            </slot>
        </sw-label>
    {% endblock %}

    {% block sw_extension_store_error_card_title %}
        <h2
            v-if="title"
            class="sw-extension-store-error-card__title"
            v-html="title"
        />
    {% endblock %}

    {% block sw_extension_store_error_card_message %}
        <div class="sw-extension-store-error-card__message">
            <slot />
        </div>
    {% endblock %}

    {% block sw_extension_store_error_card_actions %}
        <div class="sw-extension-store-error-card__actions">
            <slot name="actions" />
        </div>
    {% endblock %}
</sw-meteor-card>
{% endblock %}
